export const SERVICE_FAILURE = 'SERVICE_FAILURE';
export const LOAD_CHECKOUT_FAILURE = 'LOAD_CHECKOUT_FAILURE';
export const LOAD_CHECKOUT_DATA = 'LOAD_CHECKOUT_DATA';
export const LOAD_CHECKOUT_DATA_SUCCESS = 'LOAD_CHECKOUT_DATA_SUCCESS';
export const LOAD_SOLD_TO_DETAILS_SUCCESS = 'LOAD_SOLD_TO_DETAILS_SUCCESS';
export const LOAD_CREDIT_CARDS_FAILURE = 'LOAD_CREDIT_CARDS_FAILURE';
export const LOAD_CREDIT_CARDS_DATA = 'LOAD_CREDIT_CARDS_DATA';
export const LOAD_CREDIT_CARDS_DATA_SUCCESS = 'LOAD_CREDIT_CARDS_DATA_SUCCESS';
export const ADD_ADDRESS_FAILURE = 'ADD_ADDRESS_FAILURE';
export const ADD_ADDRESS = 'ADD_ADDRESS';
export const ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS';
export const PLACE_ORDER = 'PLACE_ORDER';
export const PLACE_ORDER_FAILURE = 'PLACE_ORDER_FAILURE';
export const ADD_CREDITCARD_FAILURE = 'ADD_CREDITCARD_FAILURE';
export const ADD_CREDITCARD = 'ADD_CREDITCARD';
export const ADD_CREDITCARD_SUCCESS = 'ADD_CREDITCARD_SUCCESS';
export const RETRIEVE_SETUP_INTENT_PAYMENT_ID = 'RETRIEVE_SETUP_INTENT_PAYMENT_ID';
export const RETRIEVE_SETUP_INTENT_PAYMENT_ID_SUCCESS = 'RETRIEVE_SETUP_INTENT_PAYMENT_ID_SUCCESS';
export const RETRIEVE_SETUP_INTENT_PAYMENT_ID_FAILURE = 'RETRIEVE_SETUP_INTENT_PAYMENT_ID_FAILURE';
export const REVIEW_ORDER = 'REVIEW_ORDER';
export const REMOVE_WHOLE_CART_SUCCESS = 'REMOVE_WHOLE_CART_SUCCESS';
export const REMOVE_WHOLE_CART_FAILURE = 'REMOVE_WHOLE_CART_FAILURE';
export const LOAD_CHECKOUT_USER_DATA_SUCCESS = 'LOAD_CHECKOUT_USER_DATA_SUCCESS';
export const LOAD_QUOTE_DETAILS_DATA = 'LOAD_QUOTE_DETAILS_DATA';
export const QUOTE_ORDER_MERGE_ADDRESS = 'QUOTE_ORDER_MERGE_ADDRESS';
export const CART_TO_ORDER_ANALYTICS = 'CART_TO_ORDER_ANALYTICS';
export const QUOTE_TO_ORDER_ANALYTICS = 'QUOTE_TO_ORDER_ANALYTICS';
export const CONTINUE_TO_PAYMENT = 'CONTINUE_TO_PAYMENT';
export const RETRIEVE_PAYMENT_TOKEN_SUCCESS = 'RETRIEVE_PAYMENT_TOKEN_SUCCESS';
export const RETRIEVE_PAYMENT_TOKEN_FAILURE = 'RETRIEVE_PAYMENT_TOKEN_FAILURE';
export const RETRIEVE_PAYMENT_TOKEN_UPDATE = 'RETRIEVE_PAYMENT_TOKEN_UPDATE';
